import React from 'react';
import '@deere/ux.uxframe-core/dist/css/uxframe-2019.3.0.min.css';
import {
    Container, Row, Card, Col
} from '@deere/ux.uxframe-react';


function AdminRequest() {
    return (
        <div className="uxf-main-container-side-nav">

            <Container fluid>
                <Row className="mb-2">
                    <Col>
                        <Card className="py-3 px-4">
                            <Row>
                                <h1 className="mb-3">CUT Admin</h1>
                            </Row>
                            <Row>
                                <h3>Coming soon</h3>
                            </Row>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default AdminRequest;
